function add_filter_bubbles(name, term_id){
    if(name){
        $('.filter-bubbles').append('<span class="filter-bubble" data="' + term_id + '"><svg class="mr-1" width="10" height="10"><use xlink:href="#xmark"></use></svg>' + name + '</span>');
    }
}

function removeBubble(data){
    if(data === 'price' ){
        reset_price_filter();
    }else{
        $('#'+data).prop('checked',false);
    }
    $('.filter-bubble[data="'+data+'"]').remove();
    prepare_to_filter();
}

var prepareToFilterInverval;
function prepare_to_filter(){
    // $('#page_num').val(1);
    clearInterval(prepareToFilterInverval);
    const milliseconds = 10;
    const elem = $('.filter_prepare_line');
    let width = 1;

    if($('#instant_filter').val()){
        ajax_filter_products();
    }else {
        prepareToFilterInverval = setInterval(function(){
            if (width >= 100) {
                clearInterval(prepareToFilterInverval);
                ajax_filter_products();
            } else {
                width++;
                elem.css('width', width + '%');
            }
        }, milliseconds);
    }
}

function ajax_filter_products(pagination_init = false){

    let getParameters = '?f=1';
    let page_num = 1;
    let instock = 0;
    let onsale = 0;
    let news = 0;
    let search = 0;
    let no_sidebar = 0;

    $('.filter-bubbles').html('');

    if(pagination_init){
        let page_num_input = $('#page_num');
        if(page_num_input.length){
            page_num = page_num_input.val();
        }else{
            let pageParam = new URLSearchParams(window.location.search)
            if(pageParam.has('page_num')){
                page_num = pageParam.get('page_num');
                page_num = parseInt(page_num);
            }
        }
    }

    if( $('#search_string').val()){
        search = $('#search_string').val()
        getParameters += '&s='+search;
    }

    if (  $('#filter_news').is(':checked')  ) {
        news = 1;
        add_filter_bubbles($('#filter_news').data('filter_name'), 'filter_news');
        getParameters += '&news=1';
    }

    if (  $('#filter_onsale').is(':checked')  ) {
        onsale = 1;
        add_filter_bubbles($('#filter_onsale').data('filter_name'), 'filter_onsale');
        getParameters += '&onsale=1';
    }

    if (  $('#filter_instock').is(':checked') ) {
        instock = 1;
        add_filter_bubbles($('#filter_instock').data('filter_name'), 'filter_instock');
        getParameters += '&instock=1';
    }

    if( $('#no_sidebar').length ){
        no_sidebar = 1;
    }

    let data_to_send = {
        action: 'product_filter',
        page_num: page_num,
        search: search,
        onsale: onsale,
        news: news,
        no_sidebar: no_sidebar,
        instock: instock,
        current_category_id: $('#current_category_id').val(),
        filter: []
    };

    let previous_type = '';
    let ids = [];
    const order_by = $('.orderby').val();

    /* price filter do not have to be on every catalog page */
    const price_slider = $('.js-price-filter-input');
    if(price_slider.length){
        const price_from = parseInt(price_slider[0].value);
        const price_min = parseInt(price_slider[0].min);

        const price_to = parseInt(price_slider[1].value);
        const price_max = parseInt(price_slider[1].max);

        if(price_from > price_min){
            getParameters += '&price_from='+price_from;
            data_to_send['price_from'] = price_from;
        }

        if(price_to < price_max){
            getParameters += '&price_to='+price_to;
            data_to_send['price_to'] = price_to;
        }

        if(price_from > price_min || price_to < price_max){
            add_filter_bubbles( price_slider[0].dataset.bubble + ': '+ price_from + ' - '+ price_to + ' '+price_slider[0].dataset.currency, 'price');
        }
    }

    if(order_by != 'name'){
        getParameters += '&orderby='+order_by;
        data_to_send['orderby'] = order_by;
    }

    const checkboxes = $('input.filter-checkbox:checked');
    const checkboxes_length = checkboxes.length;

    if(checkboxes_length){
        checkboxes.each(function(index, item) {
            term_type = $(item).data('term_type');
            let name = $(item).data('term_name');
            let term_id = $(item).data('term_id');
            let attribute_wrapper = $(item).parents('.filter-item-wrapp');
            let bubble_attribute = $('.attribute-label', attribute_wrapper ).text();
            let attr_unit = attribute_wrapper.data('attr_unit');
            if(attr_unit){
                name += ' '+attr_unit;
            }
            add_filter_bubbles(bubble_attribute+': '+name, term_type + '-' + term_id);

            if(term_type == previous_type || previous_type == ''){
                ids.push(term_id);
            }else{
                let obj = {};
                obj[previous_type] = ids;
                data_to_send.filter.push(obj);
                ids = [];
                ids.push(term_id);
            }
            previous_type = term_type;
            getParameters  += '&' + term_type + '[]'+'=' + term_id;

        });
        let obj = {};
        obj[term_type] = ids;
        data_to_send.filter.push(obj);
    }

    if(page_num > 1){
        getParameters += '&page_num=' + page_num;
    }

    window.history.replaceState( {} , '', getParameters );

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            $('#products_loop').html(response);
            $('.filter_prepare_line').css('width', 0);
            lazyLoadInstance.update();
            if ( typeof after_ajax_filter == 'function' ) {
                after_ajax_filter();
            }
        }
    })
}

/* fire up filter */

$(document).on('click', '.filter-bubbles .filter-bubble', function(){
    const data = $(this).attr('data');
    removeBubble(data);
})

$('.js-orderby').change(function(){
    ajax_filter_products();
})

$('.filter-checkbox, .filter_meta').on('change', function(){
    if (!$(this).is(':checked')) {
        const term_type = $(this).data('term_type');
        const term_id = $(this).data('term_id');
        removeBubble(term_type + '-' + term_id);
    }else{
        prepare_to_filter();
    }
});

$('.js-remove-product-filter-options').click(function(){
    $('.filter-checkbox, .filter_meta').prop('checked',false);
    reset_price_filter();
    prepare_to_filter();
})

$('.js-hide-filter').click(function(){
    $('#filter-aside').slideToggle();
    if($(this).hasClass('show')){
        $(this).text($(this).data('show-text')).removeClass('show');
    }else{
        $(this).text($(this).data('hide-text')).addClass('show');
    }
})

$('.js-show-all-attributes').click(function(){
    let wrapper = $(this).parents('.filter-item-wrapp');
    $('.filter-attr-line.hide', wrapper).slideDown(function(){
        $('.filter-attr-line.hide', wrapper).removeClass('hide');
    })
    $(this).hide();
    $('.js-show-less-attributes', wrapper).show();
})

$('.js-show-less-attributes').click(function(){
    let wrapper = $(this).parents('.filter-item-wrapp');
    $('.filter-attr-line', wrapper).slice($(this).data('show-lines')).slideUp().addClass('hide');
    $(this).hide();
    $('.js-show-all-attributes', wrapper).show();
})
